/* eslint-disable indent */

export function isJSONParsable(str: string) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

export function isJSONParsableQuick(str: string): boolean {
  // Check if the string is too short to be valid JSON
  if (str.length < 2) {
    return false;
  }

  // Check if it starts and ends with valid JSON characters
  const firstChar = str[0];
  const lastChar = str[str.length - 1];

  if (
    (firstChar !== '{' && firstChar !== '[') ||
    (lastChar !== '}' && lastChar !== ']')
  ) {
    return false;
  }

  // Optional: Check for balanced braces/brackets
  let braceCount = 0;
  let bracketCount = 0;

  for (let i = 0; i < Math.min(str.length, 1000); i++) {
    // Limit to first 1000 chars
    if (str[i] === '{') {
      braceCount++;
    }

    if (str[i] === '}') {
      braceCount--;
    }

    if (str[i] === '[') {
      bracketCount++;
    }

    if (str[i] === ']') {
      bracketCount--;
    }

    if (braceCount < 0 || bracketCount < 0) {
      return false;
    }
  }

  // If all checks pass, fall back to actual parsing
  try {
    // JSON.parse(str)
    return true;
  } catch (e) {
    return false;
  }
}
